import React from "react";
import { Card, message } from "antd";
import { CopyOutlined } from "@ant-design/icons";

interface DonationMethod {
  bank_name: string;
  logo_image_ids: string[];
  iban_list: { label: string; iban: string }[];
  acc_holder_name: any;
}

interface DonationMethodCardProps {
  method: DonationMethod;
}

const DonationMethodCard = ({ method }: DonationMethodCardProps) => {
  const copyToClipboard = (iban: string) => {
    navigator.clipboard
      .writeText(iban)
      .then(() => {
        message.success("تم نسخ رقم الآيبان");
      })
      .catch(() => {
        message.error("فشل نسخ رقم الآيبان");
      });
  };

  return (
    <Card className="takaful--donation-method-card">
      <div className="takaful--donation-card-inner">
        <div className="takaful--donation-logo-container">
          <img
            alt={method.bank_name}
            src={method.logo_image_ids[0]}
            className="takaful--donation-logo"
          />
        </div>

        <h3 className="takaful--donation-bank-name">{method.bank_name}</h3>

        <p className="takaful--iban-label">رقم الآيبان</p>

        <div className="takaful--iban-list">
          {method.iban_list.map((iban, index) => (
            <div key={index} className="takaful--iban-item">
              <span
                className="takaful--iban-number"
                style={{ direction: "rtl" }}
              >
                {iban.label && iban.label + " : "} {iban.iban}
              </span>
              <CopyOutlined
                className="takaful--copy-icon"
                onClick={() => copyToClipboard(iban.iban)}
              />
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
};

export default DonationMethodCard;
